<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.MANAGE_SERVICES_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }"
                                                    @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#"
                                                    :class="{ active: activeTab === 'published' }"
                                                    @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#"
                                                    :class="{ active: activeTab === 'unpublished' }"
                                                    @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="seachServicesInput" type="text" placeholder="Search Services"
                                                v-model="searchedText"
                                                @keyup.enter="fetchServices(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addServicesBtn" class="add-btn-admin" :class="{ 'active': showAddForm }"
                                                @click="showAddForm = true, selectedServices = [], selectAll = false, cancelEdit() ">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_SERVICE_BUTTON }}
                                            </button>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm"
                                        v-if="selectedServices.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedServices.length }} entries selected</span>
                                                    <button id="tagCloseBtn"
                                                        @click="selectedServices = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal"
                                                data-bs-target="#deletePop" @click="setDeleteMode('all')">
                                                {{ constants.DELETE_ALL_BUTTON }}
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>
                                    {{ constants.ADD_NEW_SERVICE_TEXT }}
                                </h2>
                                <div class="add-banner-image-box">
                                    <form id="addServicesForm" @submit.prevent="submitForm">


                                        <div class="admin-input-field">
    <label>{{ constants.SELECT_PAGE_LABEL }}</label>
    <select id="servicesPgSelectPageSelectBox" class="admin-selectbox" v-model="newService.selectedPage">
        <option value="">Select Page</option>
        <option v-for="(value, key) in pageChoices" :key="key" :value="value">{{ key }}</option>
    </select>
    <div class="error-msg" v-if="formSubmitted && !newService.selectedPage">{{ errMsg }}</div>
</div>

<div class="admin-input-field">
    <label>{{ constants.TITLE_LABEL }}</label>
    <input id="servicesPgTitleInput" type="text" v-model="newService.title" placeholder="Enter the Title" />
    <div class="error-msg" v-if="formSubmitted && !newService.title">{{ errMsg }}</div>
</div>

<div class="admin-input-field">
    <label>{{ constants.SUB_HEADING_LABEL }}</label>
    <ckeditor placeholder="Sub Heading" class="text-editer" id="servicesPgSubHdInput" :editor="editor" v-model="newService.shortDescription" :config="editorConfig"></ckeditor>
    <div class="error-msg" v-if="formSubmitted && !newService.shortDescription">{{ errMsg }}</div>
</div>

<div class="admin-input-field">
    <label>{{ constants.DESCRIPTION_LABEL }}</label>
    <ckeditor placeholder="Description" class="text-editer" id="servicesPgDescInput" :editor="editor" v-model="newService.description" :config="editorConfig"></ckeditor>
    <div class="error-msg" v-if="formSubmitted && !newService.description">{{ errMsg }}</div>
</div>

<div class="admin-input-field">
    <label>{{ constants.SERVICE_IMAGE_LABEL }}</label>
    <div class="image-upload-input upload-banner-image">
        <div :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
            <div class="file-input-box">
                <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                @click="clearUploadedImage(false, 'service-image')"></button>
                <input id="addServicesPgFileInput" type="file" @change="handleFileUpload($event, false)" accept="image/jpeg,image/jpg,image/png" />
            </div>
            <div class="image-upload-input-item-in" v-if="!imageUploaded">
                <div class="image-upload-input-item-icon">
                    <img src="@/assets/images/admin-img/image-icon.svg" alt="" />
                </div>
                <span>{{ constants.ADD_IMAGE_LABEL }}</span>
            </div>
            <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                <img :src="imageUrl" alt="" class="mCS_img_loaded">
            </div>
        </div>
    </div>
    <div class="error-msg" v-if="formSubmitted && !selectedFile">{{ errMsg }}</div>
</div>

<div class="admin-input-field">
    <label>{{ constants.SERVICE_ICON_LABEL }}</label>
    <div class="image-upload-input upload-icon-image">
        <div :class="['image-upload-input-item', { 'uploaded-done': iconUploaded }]">
            <div class="file-input-box">
                <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                @click="clearUploadedImage(false, 'service-icon')"></button>
                <input id="addServicesPgIconFileInput" type="file" @change="handleIconUpload($event, false)" accept="image/jpeg,image/jpg,image/png" />
            </div>
            <div class="image-upload-input-item-in" v-if="!iconUploaded">
                <div class="image-upload-input-item-icon">
                    <img src="@/assets/images/admin-img/upload-icon.svg" alt="" />
                </div>
                <span>{{ constants.UPLOAD_ICON_LABEL }}</span>
            </div>
            <div class="image-upload-input-item-uploaded" v-if="iconUploaded">
                <img :src="iconUrl" alt="" class="mCS_img_loaded">
            </div>
        </div>
    </div>
    <div class="error-msg" v-if="formSubmitted && !selectedIconFile">{{ errMsg }}</div>
</div>

                                        <div class="admin-input-field-submit">
                                            <button id="servicesPgSubmitBtn" type="submit"
                                                class="admin-btn-outline-primary add-new-cancel" :disabled="isSubmitting">
                                                {{ constants.SUBMIT_BUTTON }}
                                            </button>
                                            <button id="servicesPgSubmitBtn" type="button"
                                                class="admin-btn-outline-secondary add-new-cancel" @click="resetForm">
                                                {{ constants.CANCEL_BUTTON }}
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section admin-services-section', { 'show-edit-item-outer': editFormSubmitted }]"
                            v-if="editServicesData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox"
                                                        class="css-checkbox" @change="toggleSelectAll"
                                                        :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>
                                            <div class="admin-item-image">{{ constants.IMAGE_LABEL }}</div>
                                            <div class="admin-item-sm-title" @click="toggleSort('title')" style="cursor: pointer;">{{ constants.TITLE_LABEL }}
                                                <button v-if="sortBy === 'title' || sortBy === '-title'" class="sorting-btn" :class="{ 'sorted': sortBy === '-title' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-selected-page" @click="toggleSort('selectedPage')" style="cursor: pointer;">{{ constants.SELECTED_PAGE_LABEL }}
                                                <button v-if="sortBy === 'selectedPage' || sortBy === '-selectedPage'" class="sorting-btn" :class="{ 'sorted': sortBy === '-selectedPage' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-sort-desc" @click="toggleSort('shortDescription')" style="cursor: pointer;">{{ constants.SUB_HEADING_LABEL }}
                                                <button v-if="sortBy === 'shortDescription' || sortBy === '-shortDescription'" class="sorting-btn" :class="{ 'sorted': sortBy === '-shortDescription' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-sm-desc" @click="toggleSort('description')" style="cursor: pointer;">{{ constants.DESCRIPTION_LABEL }}
                                                <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }">
                                                </button>
                                            </div>
                                            <div class="admin-item-icon">{{ constants.ICON_LABEL }}</div>
                                            <div class="admin-item-actions">{{ constants.ACTIONS_LABEL }}</div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                    <div class="admin-item-list-btm">
                                        <div ref="sortableList">
                                        <div v-for="(service, index) in editServicesData" :key="service.id"
                                            :class="['admin-item-box', { 'show-edit-item': service.editing }]">
                                            <div class="admin-item-box-top">
                                                <div class="admin-item-list-row">
                                                    <div class="admin-item-checkbox">
                                                        <div class="admin-checkbox-input">
                                                            <input name="cssCheckbox" :id="'demo_opt_' + service.id"
                                                                type="checkbox" class="css-checkbox"
                                                                @change="toggleServiceSelection(service.id)"
                                                                :checked="selectedServices.includes(service.id)">
                                                            <label :for="'demo_opt_' + service.id"></label>
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-image">
                                                        <div class="sm-img">
                                                            <img :src="getCdnImageAddress(service.serviceImage, `w_40,h_41/`) || '@/assets/images/admin-img/demo-img/item-img-6.jpg'"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-sm-title text-limit">
                                                        {{ service.title }}
                                                        
                                                    </div>
                                                    <div class="admin-item-selected-page text-limit">
                                                        {{ service.selectedPage }}</div>
                                                    <div class="admin-item-sort-desc text-limit">
                                                        {{ useStripHtml(service.shortDescription) }}
                                                    </div>
                                                    <div class="admin-item-sm-desc text-limit">
                                                        {{ useStripHtml(service.description) }}
                                                    </div>
                                                    <div class="admin-item-icon">
                                                        <div class="uploaded-icon-sm">
                                                            <img :src="getCdnImageAddress(service.serviceIcon, `w_21,h_23/`) || '@/assets/images/admin-img/demo-img/demo-icon-1.png'"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="admin-item-actions">
                                                        <ul class="admin-action-link">
                                                            <li><button id="servicePgEditBtn" class="editBtn"
                                                                    @click="editService(index), showAddForm = false">{{
                                                                        constants.EDIT_BUTTON
                                                                    }}</button></li>
                                                            <li>
                                                                <button id="servicePgDeleteBtn" data-bs-toggle="modal"
                                                                    data-bs-target="#deletePop"
                                                                    @click="setDeleteMode('single', service.id), showAddForm = false, cancelEdit()">
                                                                    {{ constants.DELETE_BUTTON }}
                                                                </button>
                                                            </li>

                                                            <li><button id="servicePgUnPublishBtn"
                                                                    class="primary-outline-btn"
                                                                    v-if="service.status === 1"
                                                                    @click="changeServiceStatus(service.id, 0)">
                                                                    {{ constants.UNPUBLISH_BUTTON }}
                                                                </button>
                                                                <button id="servicePgPublishBtn"
                                                                    class="primary-outline-btn"
                                                                    v-else-if="service.status === 0"
                                                                    @click="changeServiceStatus(service.id, 1)">
                                                                    {{ constants.PUBLISH_BUTTON }}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="clear"></div>
                                                </div>
                                            </div>
                                            <div class="admin-item-box-btm" v-if="service.editing">
                                                <div class="add-banner-image-section">
                                                    <h2>
                                                        {{ constants.EDIT_SERVICE_TEXT }}
                                                    </h2>
                                                    <div class="add-banner-image-box">


                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.SELECT_PAGE_LABEL }}
                                                            </label>
                                                            <select id="servicesPgSelectPageSelectBox"
                                                                class="admin-selectbox"
                                                                v-model="editServiceData.selectedPage">
                                                                <option value="">Select Page</option>
                                                                <option v-for="(value, key) in pageChoices" :key="key"
                                                                    :value="value">{{ key }}</option>
                                                            </select>
                                                            <div class="error-msg" v-if="!editServiceData.selectedPage">
                                                                {{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.TITLE_LABEL }}
                                                            </label>
                                                            <input id="servicesPgTitleInput" type="text"
                                                                placeholder="Enter the Title"
                                                                v-model="editServiceData.title" />
                                                            <div class="error-msg" v-if="!editServiceData.title">
                                                                {{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.SUB_HEADING_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Description" class="text-editer"
                                                                id="servicesPgSubHdInput" :editor="editor"
                                                                v-model="editServiceData.shortDescription"
                                                                :config="editorConfig"></ckeditor>
                                                            <div class="error-msg"
                                                                v-if="!editServiceData.shortDescription">{{ errEditMsg }}
                                                            </div>


                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.DESCRIPTION_LABEL }}
                                                            </label>
                                                            <ckeditor placeholder="Description" class="text-editer"
                                                                id="servicesPgDescInput" :editor="editor"
                                                                v-model="editServiceData.description"
                                                                :config="editorConfig"></ckeditor>
                                                            <div class="error-msg" v-if="!editServiceData.description">
                                                                {{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>

                                                                {{ constants.SERVICE_IMAGE_LABEL }}
                                                            </label>
                                                            <div class="image-upload-input upload-banner-image">
                                                                <div class="image-upload-input-item uploaded-done">
                                                                    <div class="file-input-box">
                                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                                        @click="clearUploadedImage(true, 'service-image')"></button>
                                                                        <input id="editServicesPgFileInput" type="file"
                                                                            @change="handleFileUpload($event, true)"
                                                                            accept="image/jpeg,image/jpg,image/png" />
                                                                    </div>
                                                                    <div class="image-upload-input-item-uploaded">
                                                                        <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />


                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div class="error-msg" v-if="!selectedFile && !editimageSrc">{{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field">
                                                            <label>
                                                                {{ constants.SERVICE_ICON_LABEL }}
                                                            </label>
                                                            <div class="image-upload-input upload-icon-image">
                                                                <div class="image-upload-input-item uploaded-done">
                                                                    <div class="file-input-box">
                                                                        <button class="image-upload-input-item-delete-btn" id="uploaded-img-delete-btn" type="button"
                                                                        @click="clearUploadedImage(true, 'service-icon')"></button>
                                                                        <input id="editServicesPgIconFileInput" type="file"
                                                                            @change="handleIconUpload($event, true)"
                                                                            accept="image/jpeg,image/jpg,image/png" />
                                                                    </div>
                                                                    <div class="image-upload-input-item-uploaded">
                                                                        <img :src="editIconSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div class="error-msg" v-if="!selectedEditIconFile && !editIconSrc">{{ errEditMsg }}</div>
                                                        </div>

                                                        <div class="admin-input-field-submit">
                                                            <button id="servicesPgSubmitBtn"
                                                                class="admin-btn-outline-primary"
                                                                @click="submitEditForm(service.id)">
                                                                {{ constants.SUBMIT_BUTTON }}
                                                            </button>
                                                            <button id="servicesPgSubmitBtn"
                                                                class="admin-btn-outline-secondary addNewCancel"
                                                                @click="cancelEdit">
                                                                {{ constants.CANCEL_BUTTON }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)"
                                                v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>

        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
            aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal"
                            @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<script lang="ts">
import { defineComponent, ref,nextTick } from 'vue';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Swal from 'sweetalert2';
import { PageChoices } from '@/enums/PageChoices';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Service {
    id: number;
    selectedPage: string;
    title: string;
    shortDescription: string;
    description: string;
    serviceImage: string;
    serviceIcon: string;
    status: number;
    editing?: boolean;
    Created_at?: string
    position: number; // Add position field
}
export default defineComponent({
    name: "Services",
    data() {
        return {
            constants: constants,
            editor: ClassicEditor,
            activeTab: 'all',
            imageSrc: '',
            iconSrc: '',
            editimageSrc: '',
            editIconSrc: '',
            showAddForm: false,
            limit: 10,
            errMsg: '',
            errEditMsg: '',
            searchTempVar: '',
            selectedFile: null as File | null,
            selectedIconFile: null as File | null,
            selectedEditFile: null as File | null,
            selectedEditIconFile: null as File | null,
            imageUploaded: false,
            iconUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            services: [] as Service[],
            editServicesData: [] as Service[],
            selectedServices: [] as number[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            editorConfig: {
                toolbar: {
                    items: [
                        'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'undo', 'redo', '|', 'insertTable',
                    ]
                },
            },
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            newService: {
                selectedPage: '',
                title: '',
                shortDescription: '',
                description: '',
                serviceImage: '',
                serviceIcon: ''
            },
            editServiceData: {
                selectedPage: '',
                title: '',
                shortDescription: '',
                description: '',
                serviceImage: '',
                serviceIcon: ''
            },
            serviceToDelete: null as number | null,
            deleteMode: 'all' as 'all' | 'single',
            pageChoices: PageChoices,
            isSubmitting: false,
            isDragging: false, // Add for drag state
            sortableInstance: null as Sortable | null,
            formSubmitted: false, // New flag for form submission
            sortBy: '-position' as string,
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {
        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        iconUrl(): string {
            return this.iconSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editIcon(): string {
            return this.editIconSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
    },
    components: {
        adminHeader,
        adminNavigation
    },
    created() {
        this.limit = getPaginationLimit("services", 10);
        this.fetchCounts();
        this.fetchServices();
    },
    mounted() {
    this.setupSortable(); // Initialize SortableJS on mount
    },
    methods: {
      
        setDeleteMode(mode: any, serviceId?: number) {
            this.deleteMode = mode;
            if (serviceId !== undefined) {
                this.serviceToDelete = serviceId;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteService();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false
                this.selectedServices = []
            }
        },

        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true
                        }
                    }
                };
            }
        },
        handleIconUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editIconSrc = e.target.result;
                            this.selectedEditIconFile = file;
                        } else {
                            this.iconSrc = e.target.result;
                            this.selectedIconFile = file;
                            this.iconUploaded = true
                        }
                    }
                };
            }
        },
        toggleServiceSelection(serviceId: number) {
            if (this.selectedServices.includes(serviceId)) {
                this.selectedServices = this.selectedServices.filter(id => id !== serviceId);
            } else {
                this.selectedServices.push(serviceId);
            }


        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedServices = [];
                this.selectAll = false
            } else {
                this.selectedServices = this.editServicesData.map(service => service.id);
                this.selectAll = true
            }
        },

        async submitForm() {
         this.formSubmitted = true; // Set flag on submission
    if (!this.newService.selectedPage || !this.newService.title || !this.newService.shortDescription || !this.newService.description || !this.selectedFile || !this.selectedIconFile) {
        this.errMsg = "This Field Is Required";
        return;
    }
    this.isSubmitting = true;
    const formData = new FormData();
    formData.append('selectedPage', this.newService.selectedPage);
    formData.append('title', this.newService.title);
    formData.append('shortDescription', this.newService.shortDescription);
    formData.append('description', this.newService.description);
    formData.append('serviceImage', this.selectedFile);
    formData.append('serviceIcon', this.selectedIconFile);
    try {
        const response = await fetch(`${API_BASE_URL}/service/`, {
            method: 'POST',
            body: formData
        });
        await response.json();
        this.resetForm();
        await this.fetchCounts(); // Fetch counts first
        // Adjust currentPage if needed
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
            this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
        }
        await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Fetch services with current limit
        this.imageUploaded = false;
        this.iconUploaded = false;
        Swal.fire({
            icon: 'success',
            title: 'Service Created Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
        this.formSubmitted = false; // Reset flag on success
        this.errMsg = ''; // Clear error message
    } catch (error) {
        console.error('Error submitting service:', error);
    } finally {
        this.isSubmitting = false;
    }
},
async deleteSelectedContacts() {
    try {
        await axios.delete(`${API_BASE_URL}/service/bulk_delete/`, { data: { ids: this.selectedServices } });
        this.editServicesData = this.editServicesData.filter(service => !this.selectedServices.includes(service.id));
        this.selectedServices = [];
        await this.fetchCounts(); // Update counts
        await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit); // Refresh services
        if (this.editServicesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.selectAll = false;
    } catch (error) {
        console.error('Error deleting contacts:', error);
    }
},
        async submitEditForm(serviceId: number) {
        this.formSubmitted = true; // Set flag on edit submission
    if (!this.editServiceData.selectedPage || !this.editServiceData.title || !this.editServiceData.shortDescription || !this.editServiceData.description || (!this.selectedEditFile && !this.editimageSrc) || (!this.selectedEditIconFile && !this.editIconSrc)) {
        this.errEditMsg = "This Field Is Required";
        return;
    }
    const formData = new FormData();
    formData.append('selectedPage', this.editServiceData.selectedPage);
    formData.append('title', this.editServiceData.title);
    formData.append('shortDescription', this.editServiceData.shortDescription);
    formData.append('description', this.editServiceData.description);
    if (this.selectedEditFile) {
        formData.append('serviceImage', this.selectedEditFile);
    }
    if (this.selectedEditIconFile) {
        formData.append('serviceIcon', this.selectedEditIconFile);
    }

    try {
        const response = await axios.patch(`${API_BASE_URL}/service/${serviceId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        this.cancelEdit();
        this.editFormSubmitted = false;
        Swal.fire({
            icon: 'success',
            title: 'Service Updated Successfully!',
            showConfirmButton: false,
            timer: 1500
        });
        this.formSubmitted = false; // Reset flag on success
         this.errEditMsg = ''; // Clear error message
    } catch (error) {
        console.error('Error updating service:', error);
    }
},
handleLimitChange() {
    setPaginationLimit("services", this.limit);
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
    this.selectAll = false;
    this.selectedServices = [];
    this.fetchServices(this.activeTab, this.limit, 0);
},
  
//@ts-expect-error
    async fetchServices(status = 'all', limit?: number, skip = 0, sortBy = this.sortBy) {
    const effectiveLimit = limit ?? this.limit;

    let url = `${API_BASE_URL}/service/`;
    const params = new URLSearchParams();
    if (status === 'published') params.append('status', '1');
    else if (status === 'unpublished') params.append('status', '0');

    // Only reset currentPage for a new search, preserve limit
    if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
    }
    if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = '';
    }

    params.append('limit', effectiveLimit.toString());
    params.append('skip', skip.toString());
    if (this.searchedText) {
        params.append('searchedText', this.searchedText);
    }
      params.append('sort_by', sortBy);

    try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editServicesData = response.data;
        this.totalPages = Math.ceil(this.counts[status] / effectiveLimit); // Update totalPages
        console.log('Services Fetched:', this.editServicesData.length, 'Total Pages:', this.totalPages); // Debug log
        this.setupSortable();
    } catch (error) {
        console.error('Error fetching Services:', error);
    }
},
async switchView(status: string) {
    this.currentPage = 1;
    this.activeTab = status;
    this.selectedServices = [];
    this.selectAll = false;
    this.editFormSubmitted = false;
    await this.fetchServices(status, this.limit, 0);
    if (status === 'published') {
        this.totalPages = Math.ceil(this.counts.published / this.limit);
    } else if (status === 'unpublished') {
        this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
    } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
    }
},
        async fetchCounts(searchedText?: string) {
    try {
        const baseUrl = `${API_BASE_URL}/service/count/`;
        const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';

        const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
            axios.get(`${baseUrl}${queryParam}0&status=1`),
            axios.get(`${baseUrl}${queryParam}1`),
            axios.get(`${baseUrl}${queryParam}0`)
        ]);

        this.counts = {
            all: allResponse.data.count,
            published: publishedResponse.data.count,
            unpublished: unpublishedResponse.data.count
        };

        if (this.activeTab in this.counts) {
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit); // Use this.limit
            console.log('Counts:', this.counts, 'Total Pages:', this.totalPages, 'Limit:', this.limit); // Debug log
        } else {
            console.error(`Invalid active tab: ${this.activeTab}`);
        }
    } catch (error) {
        console.error('Error fetching service counts:', error);
    }
},


        editService(index: number) {
            this.editServicesData.forEach((service, i) => {
                service.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedService = this.editServicesData[index];
            this.editServiceData = {
                selectedPage: selectedService.selectedPage,
                title: selectedService.title,
                shortDescription: selectedService.shortDescription,
                description: selectedService.description,
                serviceImage: selectedService.serviceImage || '',
                serviceIcon: selectedService.serviceIcon || ''
            };
            // Use getCdnImageAddress to ensure proper CDN URL
            this.editimageSrc = selectedService.serviceImage
                ? this.getCdnImageAddress(selectedService.serviceImage, 'w_200,h_100/')
                : '';
            // Use getCdnImageAddress to ensure proper CDN URL
            this.editIconSrc = selectedService.serviceIcon
                ? this.getCdnImageAddress(selectedService.serviceIcon, 'w_200,h_100/')
                : '';



            if (this.sortableInstance) {
              this.sortableInstance.option('disabled', true);
          }
        },

        resetForm() {
            this.newService = {
                selectedPage: '',
                title: '',
                shortDescription: '',
                description: '',
                serviceImage: '',
                serviceIcon: ''
            };
            this.selectedFile = null;
            this.selectedIconFile = null;
            this.imageSrc = '';
            this.iconSrc= '';
            this.showAddForm = false;
            this.errMsg = ''; // Clear error message
            this.formSubmitted = false; // Reset flag
            this.imageUploaded = false;
            this.iconUploaded = false;
        },

        cancelEdit() {
            this.editServicesData.forEach((service) => {
                service.editing = false;
            });
            this.editServiceData = {
                selectedPage: '',
                title: '',
                shortDescription: '',
                description: '',
                serviceImage: '',
                serviceIcon: ''
            };
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.selectedEditIconFile = null;
            this.editimageSrc = '';
            this.editIconSrc = ''
            this.errEditMsg = ''; // Clear error message

            if (this.sortableInstance) {
          this.sortableInstance.option('disabled', false);
     }
        },

        async deleteService() {
    try {
        await axios.delete(`${API_BASE_URL}/service/${this.serviceToDelete}/`);
        await this.fetchCounts();
        await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editServicesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        (this.$refs.dummyButton as HTMLElement)?.click();
    } catch (error) {
        console.error('Error deleting service:', error);
    }
},
async changeServiceStatus(serviceId: number, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());

        await axios.patch(`${API_BASE_URL}/service/${serviceId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        await this.fetchCounts();
        await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editServicesData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
    } catch (error) {
        console.error('Error updating service status:', error);
    }
},
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html : string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error('Sortable list ref not found!');
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: '.admin-item-box',
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content', // Expanded filter
          preventOnFilter: true,
          disabled: this.editFormSubmitted,
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            if (['title', '-title', 'selectedPage', '-selectedPage', 'description', '-description', 'shortDescription', '-shortDescription'].includes(this.sortBy)) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag   it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newArticlesData = [...this.editServicesData];
            const [movedItem] = newArticlesData.splice(oldIndex, 1);
            newArticlesData.splice(newIndex, 0, movedItem);

            

            const totalItems = newArticlesData.length;
            newArticlesData.forEach((item, index) => {
            item.position = totalItems - index; // Highest position for top item
            });

            // Update reactive property
            this.editServicesData = newArticlesData;

            // Prepare data for backend sync
            const reorderedItems = newArticlesData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              console.log(reorderedItems,'hhhhhhhhhh')
              await axios.post(`${API_BASE_URL}/service/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

              Swal.fire({
                icon: 'success',
                title: 'Order Updated Successfully!',
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error('Error updating order:', error);
              await this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
              Swal.fire({
                icon: 'error',
                title: 'Order Update Failed!',
                text: 'Reverted to last saved order.',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });

        console.log('Sortable instance created:', this.sortableInstance);
    });
},

clearUploadedImage(isEdit: boolean, type: 'service-image' | 'service-icon') {
		if (isEdit) {
            if(type === 'service-image'){
                this.editimageSrc = '';
                this.selectedEditFile = null;
                const fileInput = document.getElementById('editServicesPgFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
            else if(type === 'service-icon'){
                this.editIconSrc = '';
                this.selectedEditIconFile = null;
                const fileInput = document.getElementById('editServicesPgIconFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
		} else {
            if(type === 'service-image'){
                this.imageSrc = '';
                this.selectedFile = null;
                this.imageUploaded = false;
                const fileInput = document.getElementById('addServicesPgFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
            else if(type === 'service-icon'){
                this.iconSrc = '';
                this.selectedIconFile = null;
                this.iconUploaded = false;
                const fileInput = document.getElementById('addServicesPgIconFileInput') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
		}
	},

toggleSort(field: string) {
            if (this.sortBy === field) {
                this.sortBy = `-${field}`; 
            } else if (this.sortBy === `-${field}`) {
                this.sortBy = '-position'; 
            } else {
                this.sortBy = field; 
            }
            this.fetchServices(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
        },

 
  },
    
});
</script>

<style scoped>
.admin-item-box-top {
  cursor: move;
}
.admin-item-box.dragging {
  opacity: 0.5;
}
</style>